import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";
import { useNavigate } from "react-router-dom";

import dashboard_icon from "../../../assets/images/dashboard_icon.svg";

import tradeIcon from '../../../assets/images/Group 1707478641.svg';
import payearlyIcon from '../../../assets/images/Group 1707478659.svg';
import fundLyncIcon from '../../../assets/images/Group 1707478660.svg';
import crmIcon from '../../../assets/images/Group 1707478661.svg';
import ticketIcon from '../../../assets/images/Group 1707478662.svg';
import expenseIcon from '../../../assets/images/Group 1707478663.svg';
import kekaIcon from '../../../assets/images/Group 1707478664.svg';
import invoiceHubIcon from '../../../assets/images/Group 1707478673.svg';


import tradeIconGrey from '../../../assets/images/Group 1707478665.svg';
import payearlyIconGrey from '../../../assets/images/Group 1707478666.svg';
import fundLyncIconGrey from '../../../assets/images/Group 1707478667.svg';
import crmIconGrey from '../../../assets/images/Group 1707478668.svg';
import ticketIconGrey from '../../../assets/images/Group 1707478669.svg';
import expenseIconGrey from '../../../assets/images/Group 1707478670.svg';
import kekaIconGrey from '../../../assets/images/Group 1707478671.svg';
import invoiceHuIconGrey from '../../../assets/images/Group 1707478672.svg';


const OurProducts = props => {
    const [menu, setMenu] = useState(false);
    const navigate = useNavigate();
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const imageItems = [
        {
            src: tradeIconGrey,
            hoverSrc: tradeIcon,
            url: 'https://tradeasy.cashinvoice.in/',
            label: 'TradeEasy'
        },
        {
            src: payearlyIconGrey,
            hoverSrc: payearlyIcon,
            url: 'https://payearly.cashinvoice.in/',
            label: 'PayEarly'
        },
        // {
        //     src: fundLyncIconGrey,
        //     hoverSrc: fundLyncIcon,
        //     url: 'https://fundlyncuat.cashinvoice.in/',
        //     label: 'FundLync'
        // },
        {
            src: crmIconGrey,
            hoverSrc: crmIcon,
            url: 'https://crm.cashinvoice.in/',
            label: 'CRM'
        },
        {
            src: ticketIconGrey,
            hoverSrc: ticketIcon,
            url: 'https://hesk.cashinvoice.in/',
            label: 'Ticketing System'
        },
        {
            src: expenseIconGrey,
            hoverSrc: expenseIcon,
            url: 'https://vpay.cashinvoice.in/',
            label: 'Expense Tracker'
        },
        {
            src: kekaIconGrey,
            hoverSrc: kekaIcon,
            url: 'https://cashinvoice.keka.com/',
            label: 'Keka'
        },
        {
            src: invoiceHuIconGrey,
            hoverSrc: invoiceHubIcon,
            url: 'https://invoicehub.cashinvoice.in/',
            label: 'CRM'
        },
    ];

    const handleRedirect = (url) => {
        window.open(url, '_blank'); // Open URL in a new tab
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} onMouseEnter={() => setMenu(true)} onMouseLeave={() => setMenu(false)} className="d-inline-block">
                <DropdownToggle className="btn header-item" id="page-header-user-dropdown" tag="button">
                    <img src={dashboard_icon} style={{ height: "27px" }} />
                </DropdownToggle>
                <DropdownMenu className="p-3 notification_container" style={{ width: '300px' }}>
                    <div className="image-grid">
                        {imageItems.map((item, index) => (
                            <DropdownItem
                                key={index}
                                className="p-1"
                                style={{ backgroundColor: 'transparent' }}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                                onClick={() => handleRedirect(item.url)}
                            >
                                <div className={`image-container ${hoveredIndex === index ? 'hovered' : ''}`}>
                                    <img
                                        src={hoveredIndex === index ? item.hoverSrc : item.src}
                                    />
                                </div>
                            </DropdownItem>
                        ))}
                    </div>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

OurProducts.propTypes = {
    success: PropTypes.any,
    t: PropTypes.any
};

const mapStatetoProps = state => {
    const { error, success } = state.Profile;
    return { error, success };
};

export default withRouter(
    connect(mapStatetoProps, {})(withTranslation()(OurProducts))
);
